<template>
  <div
    class="drag-drop-upload"
    @dragover="handleDragOver"
    @dragleave="handleDragOver"
    @drop="handleFileSelect"
    v-if="!previewImageUrl"
  >
    <label for="file-input" class="file-input" id="file-input-container">
      <v-card
        flat
        outlined
        @click="(e) => clickInput(e)"
        height="300px"
        class="d-flex flex-column justify-center align-center py-4 pointer"
      >
        <v-icon class="mb-2"> mdi-tray-arrow-up </v-icon>
        <span class="text-h6">{{
          $t('message.pages.video.inputImages.message')
        }}</span>
        <span class="grey--text mt-1"
          >{{ $t('message.pages.video.inputImages.description') }}
        </span>
      </v-card>
    </label>
    <input
      id="file-input"
      class="d-none"
      type="file"
      accept="image/png, image/jpeg, image/gif"
      @change="handleFileInput"
      ref="fileInput"
    />
  </div>
  <div v-else class="file-results">
    <!-- eslint-disable-next-line-->
    <v-hover v-slot="{ hover }">
      <v-card
        flat
        class="d-flex flex-column justify-center align-center py-4 pointer image-preview-container"
      >
        <div
          :style="`background-image: url('${previewImageUrl}')`"
          class="image-preview preview"
        ></div>
        <v-btn
          @click="deleteImage()"
          class="btn-delete"
          filter
          icon
          :class="{ 'show-btn-delete': hover }"
        >
          <v-icon @click="deleteImage()">mdi-close</v-icon>
        </v-btn>
      </v-card>
    </v-hover>
  </div>
</template>

<script>
export default {
  name: 'DragDropFileUpload',
  props: {
    previewImage: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      dragging: false,
      results: [],
    }
  },
  computed: {
    previewImageUrl() {
      if (this.previewImage) return this.previewImage
      if (this.results) return this.results.filePreview
      return ''
    },
  },
  methods: {
    deleteImage() {
      if (this.results) {
        this.results.filePreview = ''
      }
      this.$emit('handleInput', this.results)
    },
    handleFileInput(event) {
      this.processFileInput(event.target.files)
      event.target.value = ''
    },
    handleDragOver(event) {
      event.preventDefault()
      this.dragging = event.type === 'dragover'
      event.dataTransfer.dropEffect = 'copy'
    },
    handleFileSelect(event) {
      event.preventDefault()
      this.dragging = false
      this.processFileInput(event.dataTransfer.files)
    },
    processFileInput(files) {
      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        if (file.type.match('image.*')) {
          let reader = new FileReader()
          reader.onloadend = function () {
            if (!this.results.length) this.results = undefined
            const results = {
              filePreview: reader.result,
              file: file,
            }
            this.results = results
            this.$emit('handleInput', results)
          }.bind(this)
          reader.readAsDataURL(file)
        }
      }
    },
    clearResults() {
      this.results = undefined
    },
    clickInput(e) {
      e.preventDefault()
      if (e.target.id === 'file-input') return
      this.$refs.fileInput.click()
    },
  },
}
</script>

<style scoped>
.delete-preview {
  position: absolute;
  top: 10px;
  right: 10px;
}

.image-preview-container {
  border: 1px solid var(--v-neutral-lighten3);
  padding: 1rem;
  max-height: 300px;
  background-color: gray;
  background-image: linear-gradient(45deg, #ccc 25%, transparent 25%),
    linear-gradient(135deg, #ccc 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #ccc 75%),
    linear-gradient(135deg, transparent 75%, #ccc 75%);
  background-size: 25px 27px;
  background-repeat: repeat;
  background-position: 0 0, 12.5px 0, 12.5px -12.5px, 0px 12.5px;
  position: relative;
}

.image-preview {
  position: relative;
  background-size: contain;
  background-position: center;
  width: 100%;
  height: 300px;
}

.image-preview .preview {
  width: 100%;
  min-height: 100%;
  background-color: transparent;
  z-index: 2;
}

.image-preview .blur {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  filter: blur(1px) brightness(0.8);
  left: 0px;
  background-size: cover;
  z-index: 0;
}

.btn-delete {
  color: #fff !important;
  opacity: 0;
  position: absolute;
  top: -10px;
  right: -10px;
  background: #282525;
  height: 30px !important;
  width: 30px !important;
  z-index: 4;
}

.btn-delete span i {
  height: 17px !important;
  font-size: 17px !important;
  width: 19px !important;
}

.show-btn-delete {
  opacity: 1 !important;
}
</style>
